import React, { useMemo } from 'react';
import { FrameOrientation } from 'src/types';

interface IProps {
  scale: number;
  orientation: FrameOrientation;
  border: string;
}

const TOP_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8] as const;
const SIDE_LETTERS = ['A', 'B', 'C', 'D'] as const;

const ROW_HEIGHT_PX = 15;
const CELL_CLASS_TOP = 'w-full text-center text-black';
const CELL_CLASS_TOP_FIRST = 'w-full text-center text-black !border-l-0';
const CELL_CLASS_LEFT =
  'flex h-full items-center justify-center text-center text-black';
const CELL_CLASS_LEFT_FIRST =
  'flex h-full items-center justify-center text-center text-black !border-t-0';

function ProjectFrameWrapper({ scale, orientation, border }: IProps) {
  const topLabels = orientation === 'landscape' ? TOP_NUMBERS : SIDE_LETTERS;
  const sideLabels = orientation === 'landscape' ? SIDE_LETTERS : TOP_NUMBERS;

  const styles = useMemo(
    () => ({
      row: { height: `${ROW_HEIGHT_PX * scale}px` as const },
      col: { width: `${ROW_HEIGHT_PX * scale}px` as const },
      cellHorizontal: {
        borderLeft: border,
        lineHeight: `${ROW_HEIGHT_PX * scale}px` as const,
      },
      cellVertical: {
        borderTop: border,
        lineHeight: `${ROW_HEIGHT_PX * scale}px` as const,
      },
    }),
    [scale, border],
  );

  return (
    <>
      <div className="absolute inset-0 flex flex-col">
        <div className="flex w-full flex-row" style={styles.row}>
          {topLabels.map((item, i) => (
            <span
              key={i}
              className={i === 0 ? CELL_CLASS_TOP_FIRST : CELL_CLASS_TOP}
              style={styles.cellHorizontal}
            >
              {item}
            </span>
          ))}
        </div>
        <div className="mt-auto flex w-full flex-row" style={styles.row}>
          {topLabels.map((item, i) => (
            <span
              key={i}
              className={i === 0 ? CELL_CLASS_TOP_FIRST : CELL_CLASS_TOP}
              style={styles.cellHorizontal}
            >
              {item}
            </span>
          ))}
        </div>
      </div>
      <div className="absolute inset-0 flex flex-row">
        <div className="flex h-full flex-col" style={styles.col}>
          {sideLabels.map((item, i) => (
            <span
              key={i}
              className={i === 0 ? CELL_CLASS_LEFT_FIRST : CELL_CLASS_LEFT}
              style={styles.cellVertical}
            >
              {item}
            </span>
          ))}
        </div>
        <div className="ml-auto flex h-full flex-col" style={styles.col}>
          {sideLabels.map((item, i) => (
            <span
              key={i}
              className={i === 0 ? CELL_CLASS_LEFT_FIRST : CELL_CLASS_LEFT}
              style={styles.cellVertical}
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

export default React.memo(ProjectFrameWrapper);
